/**
 * Legal footer for the public (unauthenticated) admin routes.
 * LEGAL 01.09. (b): Impressum must be reachable from every public page.
 * Absolute link — the Impressum is served by the marketing site, not the SPA.
 */
export function PublicLegalFooter() {
  return (
    <footer className="mt-6 pb-2 text-center text-sm text-muted-foreground">
      <a
        href="https://quiznudge.com/impressum.html"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        Impressum
      </a>
    </footer>
  );
}
